import { render, staticRenderFns } from "./former-member-listing.vue?vue&type=template&id=20840837&"
import script from "./former-member-listing.vue?vue&type=script&lang=js&"
export * from "./former-member-listing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports